import { render } from "./DetailComponent.vue?vue&type=template&id=d013e582&scoped=true&ts=true"
import script from "./DetailComponent.vue?vue&type=script&lang=ts"
export * from "./DetailComponent.vue?vue&type=script&lang=ts"

import "./DetailComponent.vue?vue&type=style&index=0&id=d013e582&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d013e582"]])

export default __exports__